<template>
  <div class="dialog-manage-app-wrapper">
    <el-dialog
      :title="getTitle()"
      width="80%"
      :visible="visible" @open="onDialogOpen" @close="onDialogClose">

      <div class="app-list-container" v-if="ownerAppList.length !== 0">
        <div class="app-list" v-if="ownerType === 'user'">
          <user-app-card
            v-for="userApp in ownerAppList"
            :key="userApp.user_app_id"
            :user-app="userApp"
            @edit="onUserAppEdit"
            @delete="onUserAppDelete" />
        </div>

        <div class="app-list" v-else>
          <agent-app-card
            v-for="agentApp in ownerAppList"
            :key="agentApp.user_app_id"
            :agent-app="agentApp"
            @edit="onAgentAppEdit"
            @delete="onAgentAppDelete" />
        </div>
      </div>

      <div class="empty-tips" v-else>
        <p>
          空空如也，点击添加应用按钮为当前{{ ownerType === 'user' ? '商户' : '代理商' }}添加应用吧！
        </p>
      </div>

      <div class="operation">
        <el-button
          size="medium"
          @click="onAddAppClick">添加应用</el-button>
        <el-button
          type="danger"
          size="medium"
          @click="onClockClick">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import UserAppCard from './UserAppCard'
import AgentAppCard from './AgentAppCard'

import { mapActions } from 'vuex'

export default {
  name: 'DialogManageApp',
  components: {
    UserAppCard,
    AgentAppCard
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    ownerType: {
      type: String,
      required: true
    },
    owner: {
      type: Object,
      required: true
    },
    ownerAppList: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
    }
  },
  methods: {
    ...mapActions('store', [
      'deleteUserApp',
      'deleteAgentApp'
    ]),

    getTitle () {
      if (this.ownerType === 'user') {
        return `管理用户应用 (${this.owner.username} - ${this.owner.userid})`
      } else {
        return `管理代理商应用 (${this.owner.agentname} - ${this.owner.agentid})`
      }
    },

    onUserAppEdit (userApp) {
      this.$emit('edit-app', userApp)
    },
    async onUserAppDelete (userApp) {
      try {
        await this.$confirm(
          '此操作将永久删除商户应用，是否继续？', '删除商户应用',
          { confirmButtonText: '确定', cancelButtonText: '取消' }
        )

        await this.deleteUserApp({
          user_app_id: userApp.user_app_id
        })
        this.$emit('data-change')
      } catch (err) {
        console.log(err)
      }
    },
    onAgentAppEdit (agentApp) {
      this.$emit('edit-app', agentApp)
    },
    async onAgentAppDelete (agentApp) {
      try {
        await this.$confirm(
          '此操作将永久删除代理商应用，是否继续？', '删除代理商应用',
          { confirmButtonText: '确定', cancelButtonText: '取消' }
        )

        await this.deleteAgentApp({
          agent_app_id: agentApp.agent_app_id
        })
        this.$emit('data-change')
      } catch (err) {
        console.log(err)
      }
    },

    onAddAppClick () {
      this.$emit('add-app')
    },

    onClockClick () {
      this.$emit('update:visible', false)
    },

    onDialogOpen () {
    },
    onDialogClose () {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../assets/sass/base.scss';

.dialog-manage-app-wrapper {

  .app-list-container {
    max-height: 500px;
    overflow-y: auto;

    .app-list {
      display: flex;
      flex-flow: row wrap;
      justify-content: flex-start;
      align-items: center;
    }
  }

  .empty-tips {
    text-align: center;
    padding: 30px 0;

    p {
      font-size: 18px;
      font-weight: bold;
    }
  }

  .operation {
    margin-top: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/op/store/components/DialogManageApp.vue